import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "@/store/store";
import { cloudChiprApi } from "@/services/cloudchipr.api";
import { resourceDetailsResourceCoverageDataPayloadSelector } from "@/store/resource-details/selectors/coverage-data/resourceDetailsResourceCoverageDataPayloadSelector";

export const postUsersMeOrganisationsCurrentCoverageFixedCacheKey = `postUsersMeOrganisationsCurrentCoverageFixedCacheKey`;

export const getResourceDetailsResourceCoverageDataThunk = createAsyncThunk(
  "resourceDetails/getResourceDetailsResourceCoverageData",
  async (_: void, { dispatch, getState }) => {
    const state = getState() as RootState;

    const payload = resourceDetailsResourceCoverageDataPayloadSelector(state);

    if (!payload) {
      return;
    }

    return await dispatch(
      cloudChiprApi.endpoints.postUsersMeOrganisationsCurrentCoverage.initiate(
        payload,
        { fixedCacheKey: postUsersMeOrganisationsCurrentCoverageFixedCacheKey },
      ),
    ).unwrap();
  },
);
